routes.$inject = [ '$stateProvider', '$urlRouterProvider', '$locationProvider' ]

export default function routes($stateProvider, $urlRouterProvider, $locationProvider) {
	$locationProvider.html5Mode(true)

	$stateProvider
		.state('evaluations', {
			abstract: false,
			url     : '/app/evaluations',
			views   : {
				'': {
					template: require('../../../layout/layout.html'),
				},
				'content': {
					template: require('../../../layout/contentNoBreadcrumb.html'),
				},
				'aside': {
					template  : require('../../../layout/aside.html'),
					controller: 'AsideCtrl',
				},
				'header': {
					template  : require('../../../layout/header.html'),
					controller: 'HeaderCtrl',
				},
				'chatbox': {
					template    : require('../chatbox/chatbox.html'),
					controller  : 'ChatboxController',
					controllerAs: 'chatbox',
				},
				'footer': {
					template: require('../../../layout/footer.html'),
				},
			},
		})  
		.state('evaluations.teacherSelfAssessment', {
			abstract    : false,
			url         : '/teacherSelfAssessment',
			template    : require('./teacherSelfAssessment/teacherSelfAssessment.html'),
			controller  : 'teacherSelfAssessmentController',
			controllerAs: 'selfAssessment',
		})
		.state('evaluations.teacherAssessment', {
			abstract    : false,
			url         : '/teacherAssessment/:teacherId?:name&:userId&:workplanId&:reviewApprove',
			template    : require('./teacherAssessment/teacherAssessment.html'),
			controller  : 'teacherAssessmentController',
			controllerAs: 'selfAssessment',
			// controller: 'teacherAssessmentController',
			// controllerAs: 'teacherAssessmentController'
		})
}



// WEBPACK FOOTER //
// ./src/app/u-faculty/integralEvaluation/integralEvaluation.route.js